import React from "react";
import { Helmet } from "react-helmet";
const HelmetReact = ({ title }) => {
  return (
    <Helmet>
      <title>
        {title} || Kiubunifu
      </title>
      <meta
        name="description"
        content="Kiubunifu is a hybrid company at the intersection of people, skills, technology, and work."
      />
    </Helmet>
  );
};

export default HelmetReact;
